export default __webpack_public_path__ + "static/media/profileMockup.dc7146c7.jpg";